import { render, staticRenderFns } from "./partner-radio-button.vue?vue&type=template&id=49e58f1a"
import script from "./partner-radio-button.vue?vue&type=script&lang=js"
export * from "./partner-radio-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports